<template>
  <div>
    <TeTopCoverConsultation
      :paid="paid"
      :applied-htmlcss-trial="appliedHtmlcssTrial"
    />

    <TeCommonBannerMypage v-show="!paid && appliedHtmlcssTrial" />

    <!-- <TeCommonReskillingBanner /> -->

    <!-- <TeCommonBannerLinksTitle /> -->

    <!-- 研修ページへの導線 -->
    <TeTopBizBanner />

    <TeCommonBannerTimeLimitCpnCode
      v-if="BannerNameForShowing === 'campaign'"
      :entry-campaign="entryCampaign"
    />

    <TeCommonBannerSettlement
      v-if="BannerNameForShowing === 'settlement'"
      :entry-settlement-time-limit="entrySettlementTimeLimit"
      :entry-payment-url="entryPaymentUrl"
    />
    <TeCommonBannerTimelimit
      v-if="BannerNameForShowing === 'discount'"
      :entry-discount-time-limit="entryDiscountTimeLimit"
    />

    <TeTopRecommend />

    <!-- <TeTopCtaSecond /> -->

    <TeTopWork />

    <TeCommonAboutTechAcademy />

    <TeCommonComparisonSchoolSidejob
      :benefits="true"
      :mentoring="true"
    />

    <!-- 受講生の声 -->
    <div
      id="voice"
      class="co-bg-striped py-12 sm:py-20"
    >
      <div class="co-container-lg px-4">
        <h2 class="co-heading-2">
          受講生の声
        </h2>
        <h3 class="mb-8 text-center text-[1.25rem] font-bold md:mb-[3.25rem] md:text-[1.75rem]">
          活躍中の受講生のXでの口コミ
        </h3>

        <TeTopReviewsTwitter />

        <h3 class="mb-8 text-center text-[1.25rem] font-bold md:mb-[3.25rem] md:text-[1.75rem]">
          <FontAwesomeIcon
            :icon="faMicrophone"
            class="fa-fw mr-3 inline h-7 w-4"
          />
          受講生インタビュー
        </h3>
        <TeTopInterview />
      </div>
    </div>

    <!-- バナーWeb制作の仕事 -->
    <!-- <TeCommonBannerOccupationTest /> -->

    <!-- コース診断 -->
    <!-- <TeCommonBannerDiagnoses /> -->

    <!-- <TeCommonBannerBriefingHtmlcssTrial /> -->

    <!-- 下部固定ボタン -->
    <!-- <TeCommonButtonFixedBottom /> -->
  </div>
</template>

<script lang="ts">
import { useUser } from '~/store/user'
import { IndexServices } from '~/services/indexService'
import { scriptTagsByConfig } from '~/utility/scriptTags'
import { metaTags } from '~/utility/constants/metaTags'

import TeTopCoverConsultation from '~/components/Te/TeTop/TeTopCoverConsultation.vue'
import TeCommonBannerMypage from '~/components/Te/TeCommon/Banner/TeCommonBannerMypage/TeCommonBannerMypage.vue'
import TeCommonBannerLinksTitle from '~/components/Te/TeCommon/Banner/TeCommonBannerLinksTitle/TeCommonBannerLinksTitle.vue'
import TeCommonReskillingBanner from '~/components/Te/TeCommon/TeCommonReskillingBanner.vue'
import TeTopBizBanner from '~/components/Te/TeTop/TeTopBizBanner.vue'
import TeCommonBannerTimeLimitCpnCode from '~/components/Te/TeCommon/Banner/TeCommonBannerTimeLimitCpnCode/TeCommonBannerTimeLimitCpnCode.vue'
import TeCommonBannerSettlement from '~/components/Te/TeCommon/Banner/TeCommonBannerSettlement/TeCommonBannerSettlement.vue'
import TeCommonBannerTimelimit from '~/components/Te/TeCommon/Banner/TeCommonBannerTimelimit/TeCommonBannerTimelimit.vue'
import TeTopRecommend from '~/components/Te/TeTop/TeTopRecommend.vue'
import TeTopCtaSecond from '~/components/Te/TeTop/TeTopCtaSecond.vue'
import TeTopWork from '~/components/Te/TeTop/TeTopWork.vue'
import TeCommonAboutTechAcademy from '~/components/Te/TeCommon/TeCommonAboutTechAcademy/TeCommonAboutTechAcademy.vue'
import TeCommonComparisonSchoolSidejob from '~/components/Te/TeCommon/Comparison/TeCommonComparisonSchoolSidejob/TeCommonComparisonSchoolSidejob.vue'
import TeTopReviewsTwitter from '~/components/Te/TeTop/TeTopReviewsTwitter.vue'
import TeTopInterview from '~/components/Te/TeTop/TeTopInterview.vue'
import TeCommonBannerOccupationTest from '~/components/Te/TeCommon/Banner/TeCommonBannerOccupationTest/TeCommonBannerOccupationTest.vue'
import TeCommonBannerDiagnoses from '~/components/Te/TeCommon/Banner/TeCommonBannerDiagnoses/TeCommonBannerDiagnoses.vue'
import TeCommonBannerBriefingHtmlcssTrial from '~/components/Te/TeCommon/Banner/TeCommonBannerBriefingHtmlcssTrial/TeCommonBannerBriefingHtmlcssTrial.vue'
import TeCommonButtonFixedBottom from '~/components/Te/TeCommon/Button/TeCommonButtonFixedBottom/TeCommonButtonFixedBottom.vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCirclePlay } from '@awesome.me/kit-65d95819ce/icons/classic/regular'
import { faAngleRight, faMicrophone } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    const userStore = useUser()
    const { currentUser, appliedHtmlcssTrial, paid } = storeToRefs(userStore)

    return {
      userStore,
      currentUser,
      appliedHtmlcssTrial,
      paid,
      faCirclePlay,
      faAngleRight,
      faMicrophone,
    }
  },
  oldHead() {
    const scriptTags = scriptTagsByConfig({
      useCase: 'index',
      deviceSize: useNuxtApp().$deviceSize,
    })
    return {
      title: 'テックアカデミー',
      meta: [
        ...metaTags(
          {
            description:
              'オンラインプログラミングスクール。通過率10%を突破した現役エンジニアからマンツーマンで学べる。',
            ogUrl: '/',
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  data() {
    return {
      entryDiscountTimeLimit: null,
      entrySettlementTimeLimit: null,
      entryPaymentUrl: null,
      entryCampaign: null,
    }
  },
  computed: {
    BannerNameForShowing() {
      if (this.entrySettlementTimeLimit) {
        return 'settlement'
      } else if (this.entryCampaign) {
        return 'campaign'
      } else if (this.entryDiscountTimeLimit) {
        return 'discount'
      } else {
        return null
      }
    },
  },
  async mounted() {
    const {
      data: {
        entryDiscountTimeLimit,
        entrySettlementTimeLimit,
        entryPaymentUrl,
        entryCampaign,
      },
    } = await new IndexServices(this.$api).getTopTimeLimits()
    this.entryDiscountTimeLimit = entryDiscountTimeLimit
    this.entrySettlementTimeLimit = entrySettlementTimeLimit
    this.entryPaymentUrl = entryPaymentUrl
    this.entryCampaign = entryCampaign

    await this.userStore.getCurrentUser()
  },
  methods: {},
  components: {
    TeTopCoverConsultation,
    TeCommonBannerMypage,
    TeCommonBannerLinksTitle,
    TeCommonReskillingBanner,
    TeCommonBannerTimeLimitCpnCode,
    TeCommonBannerSettlement,
    TeCommonBannerTimelimit,
    TeTopBizBanner,
    TeTopRecommend,
    TeTopCtaSecond,
    TeTopWork,
    TeCommonAboutTechAcademy,
    TeCommonComparisonSchoolSidejob,
    TeTopReviewsTwitter,
    TeTopInterview,
    TeCommonBannerOccupationTest,
    TeCommonBannerDiagnoses,
    TeCommonBannerBriefingHtmlcssTrial,
    TeCommonButtonFixedBottom,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>
